import { createAction, props } from '@ngrx/store';
import { Troop, UserType } from '../../models';
import { ApplicantDocumentType, ApplicationType, CodeValue, Country, County, EducationType, JobVacancySource, LawEnforcementTestType, MilitaryDischargeType, PATLocation, PATResult, Permission, PolygraphDisqualificationReason, Prefix, PsychologicalResult, Race, Role, RolePermission, Sex, StateAddress, Suffix, VeteranPreferenceClaimCategory, WaiverDocument } from './../../../shared/models/lookup.models';

export const LoadStateApi = createAction(
  '[Shared][Lookup] Load State Api',
);

export const LoadStateApiSuccess = createAction(
  '[Shared][Lookup] Load State Api Success',
  props<{ data: StateAddress[] }>()
);

export const LoadStateApiError = createAction(
  '[Shared][Lookup] Load State Error Api',
  props<{ error: string }>()
);

export const LoadCountyApi = createAction(
  '[Shared][Lookup] Load County Api',
);

export const LoadCountyApiSuccess = createAction(
  '[Shared][Lookup] Load County Api Success',
  props<{ data: County[] }>()
);

export const LoadCountyApiError = createAction(
  '[Shared][Lookup] Load County Error Api',
  props<{ error: string }>()
);

export const LoadCountryApi = createAction(
  '[Shared][Lookup] Load Country Api',
);

export const LoadCountryApiSuccess = createAction(
  '[Shared][Lookup] Load Country Api Success',
  props<{ data: Country[] }>()
);

export const LoadCountryApiError = createAction(
  '[Shared][Lookup] Load Country Error Api',
  props<{ error: string }>()
);

export const LoadRaceApi = createAction(
  '[Shared][Lookup] Load Race Api',
);

export const LoadRaceApiSucess = createAction(
  '[Shared][Lookup] Load Race Api Success',
  props<{ data: Race[] }>()
);

export const LoadSexApi = createAction(
  '[Shared][Lookup] Load Sex Api',
);

export const LoadSexApiSuccess = createAction(
  '[Shared][Lookup] Load Sex Api Success',
  props<{ data: Sex[] }>()
);

export const LoadPrefixApi = createAction(
  '[Shared][Lookup] Load Prefix Api',
);

export const LoadPrefixApiSucess = createAction(
  '[Shared][Lookup] Load Prefix Api Success',
  props<{ data: Prefix[] }>()
);

export const LoadSuffixApi = createAction(
  '[Shared][Lookup] Load Suffix Api',
);

export const LoadSuffixApiSucess = createAction(
  '[Shared][Lookup] Load Suffix Api Success',
  props<{ data: Suffix[] }>()
);

export const LoadMilitaryDischargeTypeApi = createAction(
  '[Shared][Lookup] Load MilitaryDischargeType Api',
);

export const LoadMilitaryDischargeTypeApiSucess = createAction(
  '[Shared][Lookup] Load MilitaryDischargeType Api Success',
  props<{ data: MilitaryDischargeType[] }>()
);

export const LoadJobVacancySourceApi = createAction(
  '[Shared][Lookup] Load JobVacancySource Api',
);

export const LoadJobVacancySourceApiSucess = createAction(
  '[Shared][Lookup] Load JobVacancySource Api Success',
  props<{ data: JobVacancySource[] }>()
);

export const LoadVeteranPreferenceClaimCategoryApi = createAction(
  '[Shared][Lookup] Load VeteranPreferenceClaimCategory Api',
);

export const LoadVeteranPreferenceClaimCategoryApiSucess = createAction(
  '[Shared][Lookup] Load VeteranPreferenceClaimCategory Api Success',
  props<{ data: VeteranPreferenceClaimCategory[] }>()
);

export const LoadUserTypeApi = createAction(
  '[Shared][Lookup] Load User Type Api',
);

export const LoadUserTypeApiSucess = createAction(
  '[Shared][Lookup] Load User Type Api Success',
  props<{ data: UserType[] }>()
);

export const LoadTroopApi = createAction(
  '[Shared][Lookup] Load Troop Api',
);

export const LoadTroopApiSucess = createAction(
  '[Shared][Lookup] Load Troop Api Success',
  props<{ data: Troop[] }>()
);

export const LoadApplicantDocumentTypeApi = createAction(
  '[Shared][Lookup] Load Applicant Document Type Api',
);

export const LoadApplicantDocumentTypeApiSucess = createAction(
  '[Shared][Lookup] Load Applicant Document Type Api Success',
  props<{ data: ApplicantDocumentType[] }>()
);

export const LoadPATLocationApi = createAction(
  '[Shared][Lookup] Load PATLocation Api',
);

export const LoadPATLocationApiSucess = createAction(
  '[Shared][Lookup] Load PATLocation Api Success',
  props<{ data: PATLocation[] }>()
);

export const LoadPolygraphDisqualificationReasonsApi = createAction(
  '[Shared][Lookup] Load PolygraphDisqualificationReasons Api',
);

export const LoadPolygraphDisqualificationReasonsApiSucess = createAction(
  '[Shared][Lookup] Load PolygraphDisqualificationReasons Api Success',
  props<{ data: PolygraphDisqualificationReason[] }>()
);

export const LoadPsychologicalResultApi = createAction(
  '[Shared][Lookup] Load PsychologicalResult Api',
);

export const LoadPsychologicalResultApiSucess = createAction(
  '[Shared][Lookup] Load PsychologicalResult Api Success',
  props<{ data: PsychologicalResult[] }>()
);

export const LoadPATResultApi = createAction(
  '[Shared][Lookup] Load PATResult Api',
);

export const LoadPATResultApiSucess = createAction(
  '[Shared][Lookup] Load PATResult Api Success',
  props<{ data: PATResult[] }>()
);

//export class LoadPolygraphLocationApi implements Action {
//  readonly type = LookupActionTypes.LOAD_POLYGRAPH_LOCATION_API;
//}

//export class LoadPolygraphLocationApiSucess implements Action {
//  readonly type = LookupActionTypes.LOAD_POLYGRAPH_LOCATION_API_SUCCESS;
//  constructor(public payload: PolygraphLocation[]) { }
//}

export const LoadRoleApi = createAction(
  '[Shared][Lookup] Load Role Api',
);

export const LoadRoleApiSucess = createAction(
  '[Shared][Lookup] Load Role Api Success',
  props<{ data: Role[] }>()
);

export const LoadPermissionApi = createAction(
  '[Shared][Lookup] Load Permission Api',
);

export const LoadPermissionApiSucess = createAction(
  '[Shared][Lookup] Load Permission Api Success',
  props<{ data: Permission[] }>()
);

export const LoadRolePermissionApi = createAction(
  '[Shared][Lookup] Load Role Permission Api',
);

export const LoadRolePermissionApiSucess = createAction(
  '[Shared][Lookup] Load Role Permission Api Success',
  props<{ data: RolePermission[] }>()
);

export const LoadApplicationTypeApi = createAction(
  '[Shared][Lookup] Load Application Type Api',
);

export const LoadApplicationTypeApiSucess = createAction(
  '[Shared][Lookup] Load Application Type Api Success',
  props<{ data: ApplicationType[] }>()
);

export const LoadEducationTypeApi = createAction(
  '[Shared][Lookup] Load Education Type Api',
);

export const LoadEducationTypeApiSucess = createAction(
  '[Shared][Lookup] Load Education Type Api Success',
  props<{ data: EducationType[] }>()
);

export const LoadWaiverDocumentApi = createAction(
  '[Shared][Lookup] Load Waiver Document Api',
);

export const LoadWaiverDocumentApiSucess = createAction(
  '[Shared][Lookup] Load Waiver Document Api Success',
  props<{ data: WaiverDocument[] }>()
);

export const LoadCodeValuesApi = createAction(
  '[Shared][Lookup] Load Code Values Api',
);

export const LoadCodeValuesApiSucess = createAction(
  '[Shared][Lookup] Load Code Values Api Success',
  props<{ data: CodeValue[] }>()
);

export const LoadLawEnforcementTestTypeApi = createAction(
  '[Shared][Lookup] Load LawEnforcementTestType Api',
);

export const LoadLawEnforcementTestTypeApiSucess = createAction(
  '[Shared][Lookup] Load LawEnforcementTestType Api Success',
  props<{ data: LawEnforcementTestType[] }>()
);


